import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit, ViewChild
} from '@angular/core';
import { IMyDateModel, IMyOptions, MyDatePicker } from 'mydatepicker';
import { SchedulingSetting } from '../../../../../shared/models/scheduling-setting';
import { SchedulingSettingPeriod } from '../../../../../shared/models/scheduling-setting-period';
import { ScheduleService } from '../../../../services/schedule.service';
import { SchedulingSettingsDatepickerService } from '../../../../services/scheduling-settings-datepicker.service';
import * as moment from 'moment';

@Component({
    selector: 'payment-delivery-freights-freight-item-schedule',
    templateUrl: './payment.delivery.freights.freight-item.schedule.component.html',
    styleUrls: ['../../../../payment.component.scss'],
    providers: []
})
export class PaymentDeliveryFreightsFreightItemScheduleComponent implements OnInit {
    @Input('schedulingSettings') schedulingSettings: Array<SchedulingSetting> = [];
    @Output('ready') ready = new EventEmitter();
    @ViewChild('datePicker') ngxdp: MyDatePicker;
    public datePickerOptions: IMyOptions;
    public possibleSchedulingSettings: Array<SchedulingSetting> = [];
    public deliveryDateModel: string = null;
    public periodModel: SchedulingSettingPeriod = null;

    constructor(
        protected schedulingSettingsDatepickerService: SchedulingSettingsDatepickerService,
        protected scheduleService: ScheduleService
    ) {
        this.scheduleService.selectedSchedulePeriod$.subscribe(period => {
            if (this.periodModel !== null && this.periodModel.id !== period.id) {
                this.periodModel = null;
                this.deliveryDateModel = null;
                this.ngxdp.clearDate();
            }
        })
    }

    ngOnInit() {
        this.schedulingSettingsDatepickerService.setSchedulingSettings(this.schedulingSettings);
        this.datePickerOptions = this.schedulingSettingsDatepickerService.buildDatePickerOptions();
    }

    public choosePeriod(period: SchedulingSettingPeriod) {
        this.periodModel = period;
        this.scheduleService.setSchedulingSettingPeriod(this.periodModel);
        this.emitEventIfReady();
    }
    public decideToChoosePeriod(
        possibleSchedulingSettings: Array<SchedulingSetting>
    ) {
        const availablePeriods = {};
        possibleSchedulingSettings.forEach((setting: SchedulingSetting) => {
            setting.periods.forEach(settingPeriod => {
                availablePeriods[settingPeriod.id] = settingPeriod;
            });
        });

        if (Object.keys(availablePeriods).length === 1) {
            this.choosePeriod(possibleSchedulingSettings[0].periods[0]);
        }
    }
    public isChosenPeriod(period: SchedulingSettingPeriod) {
        return this.periodModel !== null
            && this.periodModel.id === period.id;
    }
    public chooseDate(event: IMyDateModel) {
        this.deliveryDateModel = `${event.date.year}-${event.date.month}-${event.date.day}`;
        this.scheduleService.setScheduleDateAsIMyDateModel(event);

        this.possibleSchedulingSettings = this.schedulingSettingsDatepickerService
            .setSchedulingSettings(this.schedulingSettings)
            .definePossibleSchedulingSettings(this.deliveryDateModel);
        this.decideToChoosePeriod(this.possibleSchedulingSettings);

        this.emitEventIfReady();
    }
    public isFuturePeriod(period: SchedulingSettingPeriod) {
        if (this.deliveryDateModel === undefined) {
            return false;
        }

        const now = moment();
        let deliveryDate = moment(this.deliveryDateModel, 'YYYY-MM-DD');
        let periodEndParts = period.end_at.split(':');

        deliveryDate.set('hours', parseInt(periodEndParts[0]));
        deliveryDate.set('minutes', parseInt(periodEndParts[1]));
        deliveryDate.set('seconds', parseInt(periodEndParts[2]));

        return deliveryDate.isAfter(now);
    }
    private emitEventIfReady() {
        if (this.deliveryDateModel !== null && this.periodModel !== null) {
            this.ready.emit();
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/payment/delivery/freights/freight-item/schedule/payment.delivery.freights.freight-item.schedule.component.ts